export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '86c95ec1-40bb-4bd7-800e-36765c711ff1';
export const MODAL_CLOSE_SEC = 2.5;
